const sids = [
  'jig',
  'talentpool',
  'edunet',
  'wconat',
  'ncph',
  't4a',
];
const sidsAba = [
  'amseu',
  'abaooe',
];
const sidsWithHiddenRegisterUsername = [
  'aba',
  'abatest',
  'abaooe',
];

export const group = (sid: string) => sids.includes(sid);
export const groupAba = (sid: string) => sidsAba.includes(sid);
export const shouldHideRegisterUsername = (sid: string) => sidsWithHiddenRegisterUsername.includes(sid);
